import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogActions, makeStyles, Typography, Box } from '@material-ui/core';
import CircularProgress from 'components/shared/CircularProgress';
import { fetchStatsRequest } from 'actions/cottages';
import StatsChart from './Chart';

const styles = makeStyles((theme) => ({
  smallMargin: {
    margin: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(4),
    },
  },
}));

const StatsRows = ({ id }) => {
  const classes = styles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [fetched, setFetched] = React.useState(false);
  const stats = useSelector((state) => state.cottages.stats[id]);

  let isLoading = false;
  let total = 0;
  let rows = [];

  if (stats) {
    ({ isLoading, total, rows } = stats);
  }

  const openDialog = () => {
    setOpen(true);

    if (!fetched) {
      setFetched(true);

      dispatch(fetchStatsRequest({ id }));
    }
  };

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="md"
        classes={{
          paper: classes.smallMargin,
        }}
        open={open}
        onClose={closeDialog}
      >
        {isLoading && <CircularProgress />}
        {!isLoading && (
          <>
            <StatsChart rows={rows} />
            <Box p={2} px={3} textAlign="right">
              <Typography>
                <FormattedMessage
                  id="cottages.views60Days"
                  defaultMessage="Views the last 60 days"
                />
                : &nbsp;
                {total || '-'}
              </Typography>
            </Box>
          </>
        )}
        <DialogActions>
          <Button aria-label="Ok" color="primary" onClick={closeDialog}>
            <FormattedMessage id="Ok" defaultMessage="Ok" />
          </Button>
        </DialogActions>
      </Dialog>
      <Button size="small" onClick={openDialog} disabled={isLoading}>
        <FormattedMessage id="Statistics" defaultMessage="Statistics" />
      </Button>
    </>
  );
};

StatsRows.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default StatsRows;
